export const fastCasinoGameDevelopmentSuperiorTextContent = {
  headingText: "Top-Notch Fast Casino Game Development",
  btnText: "Hire Fast Casino Game Developers",
  content: [
    {
      numberText: "60+",
      titleText: "Languages Covered",
    },
    {
      numberText: "50+",
      titleText: "Reliable Partners",
    },
    {
      numberText: "100%",
      titleText: "Customizations",
    },
    {
      numberText: "13+",
      titleText: "Years of Expertise",
    },
  ],
};